import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Ofwca} from "../../../shared/interface/ofwca";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {of, ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {HiperioParameterConfig} from "../../../shared/interface/hiperio-registration-config";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {delay, tap} from "rxjs/operators";


export interface ChangeParameterDialogData {
  parameter: HiperioParameterConfig;
}


@Component({
  selector: 'app-change-parameter-dialog',
  templateUrl: './change-parameter-dialog.component.html',
  styleUrls: ['./change-parameter-dialog.component.scss']
})
export class ChangeParameterDialogComponent implements  OnInit, OnDestroy  {

  changeParameterForm: FormGroup;
  partnerId: string;
  ofwca: Ofwca;
  insuranceCompany: InsuranceCompany;
  processingRequest = false;
  agencyUnitIdControl: FormControl;
  productIdControl: FormControl;
  policyEnabledControl: FormControl;
  accreditationControl: FormControl;
  paymentCashControl: FormControl;
  paymentCardControl: FormControl;
  paymentTransferControl: FormControl;
  offerSavingControl: FormControl;
  parameter?: HiperioParameterConfig;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeParameterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeParameterDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private agentsProfileHiperioService: AgentsProfileHiperioService,
    private snack: MatSnackBar,
  ) {
    this.changeParameterForm = fb.group({
      agencyUnitId: this.agencyUnitIdControl =  fb.control(null, [Validators.required]),
      productId: this.productIdControl =  fb.control(null, []),
      policyEnabled: this.policyEnabledControl =  fb.control(false, []),
      accreditation: this.accreditationControl =  fb.control(false, []),
      paymentCash : this.paymentCashControl =  fb.control(false, []),
      paymentCard: this.paymentCardControl =  fb.control(false, []),
      paymentTransfer: this.paymentTransferControl =   fb.control(false, []),
      offerSaving: this.offerSavingControl =   fb.control(false, []),
    });
    this.parameter = data.parameter;
    this.initialize(this.parameter);
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.agentsProfileHiperioService.sendUpdateParameter(this.changeParameterForm.value)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono parametry', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  initialize(parameter: HiperioParameterConfig): void {
    of(parameter)
      .pipe(
        delay(0),
        tap(() => {

          this.changeParameterForm.reset({
            agencyUnitId: parameter.agencyUnitId,
            productId: parameter.productId ? parameter.productId : null,
            policyEnabled: parameter.policyEnabled,
            accreditation: parameter.accreditation,
            paymentCash : parameter.paymentCash,
            paymentCard: parameter.paymentCard,
            paymentTransfer: parameter.paymentTransfer,
            offerSaving: parameter.offerSaving,
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe(() => {
      }
    );
  }

}
